export const parseSerializationGroups = (text: string): Array<string> | null => {
    const groups = [...new Set(text.split(/[,\n]/).map((group) => group.trim()))].filter((group) => group !== "");

    return groups.length > 0 ? groups : null;
};
